import reducer, { addAlert, removeAlert } from 'redux/modules/alert';
import AlertContainer from './AlertContainer';

export default AlertContainer;
export { reducer, addAlert, removeAlert };
